module.exports = __webpack_public_path__ + "img/madlena-tsvetkova-l.72cb81f3.webp";